import React, { useState } from 'react'
import { FaSearch, FaCar, FaTools, FaCalendarAlt, FaTachometerAlt, FaInfoCircle, FaHome, FaWhatsapp, FaInstagram, FaMapMarkerAlt } from 'react-icons/fa'
import Header from '../components/header'
import '../styles/styles.css'
import { supabase } from '../supabaseClient'

// Helper para formatear fechas dd-mm-aaaa
const formatDate = (dateString) => {
  if (!dateString) return '—'

  // Espera YYYY-MM-DD
  const [year, month, day] = dateString.split('-')
  if (!year || !month || !day) return dateString

  return `${day}-${month}-${year}`
}

export default function Home() {
  const [patente, setPatente] = useState('')
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setResult(null)

    try {
      const patenteClean = (patente || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
      console.log('Buscando patente normalizada:', patenteClean)

      const { data, error } = await supabase.rpc('get_ultimo_service', { p_patente: patenteClean })

      console.log('RPC response raw:', { data, error })

      let record = null
      if (data === null || data === 'null') {
        record = null
      } else if (Array.isArray(data)) {
        record = data[0] ?? null
      } else if (typeof data === 'string') {
        try {
          record = JSON.parse(data)
        } catch {
          record = null
        }
      } else {
        record = data
      }

      if (!record) setError('No se encontraron datos para esa patente.')
      else setResult(record)

    } catch (err) {
      console.error('Unexpected error:', err)
      setError('Error inesperado. Revisá la consola.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="home-container">
      <Header />
      
      <main className="home-hero">
        <div className="hero-content animate-fade-in">
          <h1 className="hero-title">
            Consulta tu <span className="text-accent">Service</span>
          </h1>
          <p className="hero-subtitle">
            Ingresá la patente de tu vehículo (sin espacios) para ver los datos del último service
          </p>

          <div className="search-section">
            <form className="search-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Ej: MIS301"
                  className="search-input"
                  value={patente}
                  onChange={(e) => setPatente((e.target.value || '').toUpperCase())}
                  required
                  maxLength={10}
                  style={{ textTransform: 'uppercase' }}
                />
                <FaSearch className="input-icon" />
              </div>
              <button 
                type="submit" 
                className="search-button btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="loading-spinner"></div>
                    Buscando...
                  </>
                ) : (
                  <>
                    <FaSearch />
                    Buscar Service
                  </>
                )}
              </button>
            </form>
          </div>

          {error && (
            <div className="error animate-fade-in">
              <FaInfoCircle />
              {error}
            </div>
          )}

          {result && (
            <div className="card animate-fade-in mt-6">
              <div className="mb-4 p-4 rounded-lg border border-border-color" style={{ background: 'rgba(45, 45, 45, 0.9)' }}>
                <div className="flex items-center gap-3 mb-4">
                  <FaCar size={24} className="text-accent" />
                  <h2 className="text-xl font-bold">Último Service</h2>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div className="flex items-center gap-2">
                    <FaCalendarAlt className="text-muted" />
                    <span><strong>Fecha:</strong> {formatDate(result.fecha_service)}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCar className="text-muted" />
                    <span><strong>Marca:</strong> {result.marca ?? '—'}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCar className="text-muted" />
                    <span><strong>Modelo:</strong> {result.modelo ?? '—'}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaTachometerAlt className="text-muted" />
                    <span><strong>Kilómetros:</strong> {result.km ? Number(result.km).toLocaleString() : '—'}</span>
                  </div>
                </div>
              </div>

              {(result.aceite || result.filtro_aceite || result.filtro_aire || result.filtro_combustible || result.filtro_habitaculo) && (
                <div className="mb-4 p-4 rounded-lg border border-border-color" style={{ background: 'rgba(45, 45, 45, 0.9)' }}>
                  <div className="flex items-center gap-3 mb-4">
                    <FaTools size={24} className="text-accent" />
                    <h2 className="text-xl font-bold">Cambios realizados</h2>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {result.aceite && (
                      <span className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-medium text-white" style={{ background: 'rgba(255, 107, 53, 0.8)' }}>
                        <span className="w-2 h-2 bg-white rounded-full"></span>
                        Aceite
                      </span>
                    )}
                    {result.filtro_aceite && (
                      <span className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-medium text-white" style={{ background: 'rgba(255, 107, 53, 0.8)' }}>
                        <span className="w-2 h-2 bg-white rounded-full"></span>
                        Filtro aceite
                      </span>
                    )}
                    {result.filtro_aire && (
                      <span className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-medium text-white" style={{ background: 'rgba(255, 107, 53, 0.8)' }}>
                        <span className="w-2 h-2 bg-white rounded-full"></span>
                        Filtro aire
                      </span>
                    )}
                    {result.filtro_combustible && (
                      <span className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-medium text-white" style={{ background: 'rgba(255, 107, 53, 0.8)' }}>
                        <span className="w-2 h-2 bg-white rounded-full"></span>
                        Filtro combustible
                      </span>
                    )}
                    {result.filtro_habitaculo && (
                      <span className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-medium text-white" style={{ background: 'rgba(255, 107, 53, 0.8)' }}>
                        <span className="w-2 h-2 bg-white rounded-full"></span>
                        Filtro habitáculo
                      </span>
                    )}
                      {/* Mostrar el nombre del lubricante usado si existe, con mismo estilo que los demás cambios */}
                      {result.lubricante && (
                        <span className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-medium text-white" style={{ background: 'rgba(255, 107, 53, 0.8)' }}>
                          <span className="w-2 h-2 bg-white rounded-full"></span>
                          Lubricante: {result.lubricante}
                        </span>
                      )}
                  </div>
                </div>
              )}
              
              {result.observaciones && result.observaciones.trim() !== '' && (
                <div className="mb-4 p-4 rounded-lg border border-border-color" style={{ background: 'rgba(45, 45, 45, 0.9)' }}>
                  <div className="flex items-center gap-3 mb-4">
                    <FaInfoCircle size={24} className="text-accent" />
                    <h2 className="text-xl font-bold">Observaciones</h2>
                  </div>
                  <ul className="space-y-2 text-white">
                    {result.observaciones
                      .split('\n')
                      .map(line => line.trim())        
                      .filter(line => line.length > 0) 
                      .map((line, index) => (
                        <li key={index} className="flex items-start gap-2">
                          <span className="w-2 h-2 mt-2 rounded-full bg-accent"></span>
                          <span className="leading-relaxed">{line}</span>
                        </li>
                      ))}
                  </ul>
                </div>
              )}

              {result.proximo_service && result.proximo_service > 0 && (
                <div className="mb-4 p-4 rounded-lg border border-border-color" style={{ background: 'rgba(45, 45, 45, 0.9)' }}>
                  <div className="flex items-center gap-3 mb-4">
                    <FaCalendarAlt size={24} className="text-accent" />
                    <h2 className="text-xl font-bold">Próximo Service</h2>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-white font-semibold">{Number(result.proximo_service).toLocaleString()} km</span>
                  </div>
                </div>
              )}

              {result.lubricentro && (
                <div
                  className="mb-4 p-4 rounded-lg border border-border-color"
                  style={{ background: "rgba(45, 45, 45, 0.9)" }}
                >
                  {/* Título de sección con ícono de casita */}
                  <div className="flex items-center gap-3 mb-2">
                    <FaHome size={24} className="text-accent" />
                    <h2 className="text-xl font-bold">Lubricentro</h2>
                  </div>

                  {/* Nombre del lubricentro */}
                  <p className="text-white font-bold mb-4 text-left text-2xl">{result.lubricentro}</p>

                  {/* Info itemizada con íconos */}
                  <ul className="space-y-2 text-white list-none p-0">
                    {result.lubricentro_telefono && result.lubricentro_telefono_url && (
                      <li className="flex items-center gap-2">
                        <FaWhatsapp className="text-accent" />
                        <a
                          href={result.lubricentro_telefono_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="contact-link"
                        >
                          {result.lubricentro_telefono}
                        </a>
                      </li>
                    )}
                    {result.lubricentro_instagram && result.lubricentro_instagram_url && (
                      <li className="flex items-center gap-2">
                        <FaInstagram className="text-accent" />
                        <a
                          href={result.lubricentro_instagram_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="contact-link"
                        >
                          @{result.lubricentro_instagram.replace("@", "")}
                        </a>
                      </li>
                    )}
                    {result.lubricentro_direccion && result.lubricentro_map_url && (
                      <li className="flex items-center gap-2">
                        <FaMapMarkerAlt className="text-accent" />
                        <a
                          href={result.lubricentro_map_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="contact-link"
                        >
                          {result.lubricentro_direccion}
                        </a>
                      </li>
                    )}
                  </ul>
                  {result.lubricentro_map_embed && (
                    <div className="mt-4">
                      <iframe
                        src={result.lubricentro_map_embed}
                        width="100%"
                        height="250"
                        style={{
                          border: 0,
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.25)"
                        }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Mapa del lubricentro"
                      />
                    </div>
                  )}
                </div>
              )}

            </div>
          )}
        </div>
      </main>
    </div>
  )
}
